import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, Rect, Circle } from 'react-native-svg';

const MB_SVG_Image = React.memo(
  (props: {
    /**
     * The size of the component.
     */
    size?: number;

    /**
     * The color of the component.
     */
    color?: string;

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.size ?? 24}
          height={props.size ?? 24}
          viewBox="0 0 24 24"
          fill="none"
          stroke={props.color ?? 'white'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <Rect x={3} y={3} width={18} height={18} rx={2} ry={2} />
          <Circle cx={8.5} cy={8.5} r={1.5} />
          <Path d="M21 15L16 10 5 21" />
        </Svg>
      </View>
    );
  }
);

export { MB_SVG_Image };
